import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

const LegalLayout = ({ title, lastUpdated, children, wide = false, bare = false }) => {

  // Legal pages should always open at the top, not retain scroll position.
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='min-h-screen w-full bg-black text-white flex flex-col'>
        {/* NAVBAR */}
        <div className='flex items-center w-full h-20 bg-black text-white justify-between py-4 px-6 sm:px-10 top-0 sticky z-40 border-b border-[#141414]'>
            <Link to='/' className='text-2xl sm:text-3xl ml-1 font-bold hover:scale-105 duration-200'>
                {`{codegoggins}`}
            </Link>
            <Link
              to='/'
              className='bg-[#141414] px-4 p-2 flex items-center gap-2 rounded-md hover:scale-105 duration-200'
            >
                <ArrowBackIcon className='text-[#2ea759]' fontSize='small' />
                <p className='text-sm sm:text-base'>Back to Home</p>
            </Link>
        </div>

        {/* CONTENT */}
        <div className='flex-1 w-full flex justify-center px-6 sm:px-10 py-12 sm:py-16'>
            <div className={`w-full ${wide ? 'max-w-6xl' : 'max-w-3xl'}`}>
                {!bare && (
                  <>
                    <h1 className='text-4xl sm:text-5xl font-bold antialiased'>{title}</h1>
                    {lastUpdated && (
                      <p className='text-[#8f9094] mt-3 text-sm sm:text-base'>Last updated: {lastUpdated}</p>
                    )}
                  </>
                )}
                <div className={`${bare ? '' : 'mt-8 sm:mt-10'} flex flex-col gap-8 leading-7 text-[#d4d4d4]`}>
                    {children}
                </div>
            </div>
        </div>

        {/* FOOTER */}
        <div className='p-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center text-[#8f9094] pb-8 border-t border-[#141414]'>
            <Link to='/pricing' className='hover:text-[#2ea759] duration-200'>Pricing</Link>
            <Link to='/privacy-policy' className='hover:text-[#2ea759] duration-200'>Privacy Policy</Link>
            <Link to='/terms-and-conditions' className='hover:text-[#2ea759] duration-200'>Terms &amp; Conditions</Link>
            <Link to='/refund-policy' className='hover:text-[#2ea759] duration-200'>Refund Policy</Link>
            <Link to='/shipping-policy' className='hover:text-[#2ea759] duration-200'>Shipping Policy</Link>
            <Link to='/contact-us' className='hover:text-[#2ea759] duration-200'>Contact Us</Link>
        </div>
    </div>
  )
}

// Shared sub-components so every policy page renders identically.
export const Section = ({ heading, children }) => (
  <section className='flex flex-col gap-3'>
    <h2 className='text-2xl sm:text-3xl font-semibold text-white'>{heading}</h2>
    <div className='flex flex-col gap-3'>{children}</div>
  </section>
)

export const Para = ({ children }) => (
  <p className='text-base sm:text-lg leading-8'>{children}</p>
)

export const Bullets = ({ items }) => (
  <ul className='list-disc pl-6 flex flex-col gap-2 text-base sm:text-lg'>
    {items.map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>
)

export const Accent = ({ children }) => (
  <span className='text-[#2ea759]'>{children}</span>
)

export default LegalLayout
